var _dec, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import { layout as templateLayout } from '@ember-decorators/component';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import { htmlSafe } from '@ember/template';
import layout from '../templates/components/fly-menu';
import FlyMenuItem from '@customerio/fly-components/components/fly-menu-item';

/**
  ```handlebars
  {{fly-menu
      isOpen=isOpen
      items=visibleItems
      focusedItem=focusedItem
      selectedItem=selectedItem
      labelProperty=labelProperty
      emptyMessage=emptyMessage
      itemComponent=itemComponent
      itemClicked="toggleSelection"
      onFocusItem="focusItem"}}
  ```

  @public
  @class FlyMenu
  @namespace FlyComponents
  @extends Ember.Component
*/
let FlyMenu = (_dec = templateLayout(layout), _dec(_class = (_class2 = class FlyMenu extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "containerId", 'fly-menus');
    /**
      The state of the menu
       @public
      @property isOpen
      @type Boolean
      @default false
    */
    _defineProperty(this, "isOpen", false);
    /**
      Classes passed on to to the fly-menu
       @public
      @property menuClassNames
      @type Array
      @default null
    */
    _defineProperty(this, "menuClassNames", null);
    /**
      The available items to display in the menu.
       @public
      @property items
      @type Array
      @default null
    */
    _defineProperty(this, "items", null);
    /**
      The focused item in the menu.
       @public
      @property focusedItem
      @type Integer, Object, String
      @default null
    */
    _defineProperty(this, "focusedItem", null);
    /**
      The selected item in the menu.
       @public
      @property selectedItem
      @type Integer, Object, String
      @default null
    */
    _defineProperty(this, "selectedItem", null);
    /**
      The name of the component to use for rendering items.
       @public
      @property itemComponent
      @type Component
      @default FlyMenuItem
    */
    _defineProperty(this, "itemComponent", FlyMenuItem);
    /**
      The message to display when the items array is empty.
       @public
      @property emptyMessage
      @type String
      @default 'Oops! There\'s nothing to choose from...'
    */
    _defineProperty(this, "emptyMessage", "Oops! There's nothing to choose from...");
    /**
      The positioning of the dropdown menu. Passed to ember-wormhole.
       @public
      @property renderInPlace
      @type Boolean
      @default true
    */
    _defineProperty(this, "renderInPlace", true);
    /**
      Controls whether the menu should reposition on scroll
       @public
      @property repositionOnScroll
      @type Boolean
      @default false
    */
    _defineProperty(this, "repositionOnScroll", false);
  }
  /**
    Returns the parent dropdown element
     @public
    @property findDropdown
    @type HTMLElement
    @default null
  */
  findDropdown() {
    return null;
  }
  didInsertElement() {
    super.didInsertElement(...arguments);
    this.reposition = this.reposition.bind(this);
    this.reposition();
    window.addEventListener('resize', this.reposition);
    if (this.repositionOnScroll) {
      window.addEventListener('scroll', this.reposition);
    }
  }
  didReceiveAttrs() {
    super.didReceiveAttrs();
    this.reposition();
  }
  reposition() {
    if (!this.isOpen || this.renderInPlace) {
      return;
    }
    let dropdown = this.findDropdown();
    if (isNone(dropdown)) {
      return;
    }
    let dropdownRect = dropdown.getBoundingClientRect();
    let {
      top,
      left,
      height,
      width
    } = dropdownRect;

    // If the user has scrolled, add the scroll offsets so that the dropdown is
    // positioned correctly with the trigger.
    top += window.scrollY ?? 0;
    left += window.scrollX ?? 0;
    this.set('style', htmlSafe(`
      position: absolute;
      visibility: visible;
      top: ${top + height}px;
      left: ${left}px;
      min-width: ${width}px;
      z-index: 6001;
    `));
  }

  /**
    Remove any attached event listeners before destruction.
     @private
    @method willDestroyElement
    @type Function
  */
  willDestroyElement() {
    super.willDestroyElement(...arguments);
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition);
  }
  focusItem(item) {
    this.onFocusItem(item);
  }
  itemClickedAction(item) {
    this.itemClicked(item);
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "focusItem", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "focusItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "itemClickedAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "itemClickedAction"), _class2.prototype)), _class2)) || _class);
export { FlyMenu as default };